import defaultSettings from '@/settings'

const { showSettings, fixedHeader, sidebarLogo } = defaultSettings

const state = {
  productStatus: [
    { value: false, label: '启用' },
    { value: true, label: '停用' }
  ],
  /*
  BUList
  CityList
  FileType
  HospLevel
  MatchStatus
  ProductList
  ProductStatusList
  ProductTypeList
  ProvinceList
  RegionList
  UserStatus
  ZDAttributeList
  */

  /*
  enterpriseType: [
    { value: '0', label: '医院客户' },
    { value: '1', label: '商业客户' },
    { value: '2', label: '政府客户' },
    { value: '3', label: '药店客户' }
  ],
  areaOption: [
    { value: '0', label: '东北大区' },
    { value: '1', label: '华北大区' },
    { value: '2', label: '华东大区' }
  ],
  proTypeOption: [
    { value: '0', label: 'PN全合一' },
    { value: '1', label: 'PN脂肪乳' },
    { value: '2', label: 'BM' },
    { value: '3', label: 'EN药品' }
  ],
  proGroupOption: [
    { value: '0', label: '长链脂肪乳' },
    { value: '1', label: '中长链脂肪乳' },
    { value: '2', label: '鱼油脂肪乳' },
    { value: '3', label: '三腔袋' }
  ],
  matchStatus: [
    { value: '0', label: '待匹配' },
    { value: '1', label: '已匹配' }
  ],
  departmentOption: [
    { value: '0', label: 'PN' },
    { value: '1', label: 'EN' }
  ]*/
}

export default {
  state
}
